import React from 'react';
import './Aboutus.css';
// Importá tus imágenes (ajustá las rutas)
import officeImg from '../Assets/Img/Imagen de WhatsApp 2025-10-31 a las 13.25.50_99cd6a95.jpg';
import fotoFundadores from '../Assets/Img/fotoFundadores.jpeg';
import Header from '../Header/Header.js';
import Footer from "../Footer/Footer.js"

function AboutUs() {
  const milestones = [
    { year: '2020', title: 'Fundación', description: 'Comenzamos desarrollando plataformas modulares para educación.' },
    { year: '2022', title: 'Crecimiento', description: 'Expandimos equipo y llegamos a instituciones de todo el país.' },
    { year: '2023', title: 'Polo Científico', description: 'Seleccionados por el Polo Científico Tecnológico de La Pampa.' },
    { year: '2025', title: 'TRESA', description: 'Lanzamiento de nuestra plataforma educativa integral.' },
  ];

  // Equipo (podés comentar si no tenés fotos)
  // const team = [
  //   { name: 'Nombre Apellido', role: 'Director', img: 'https://via.placeholder.com/150' },
  //   { name: 'Nombre Apellido', role: 'CTO', img: 'https://via.placeholder.com/150' },
  //   { name: 'Nombre Apellido', role: 'Diseñadora UX/UI', img: 'https://via.placeholder.com/150' },
  // ];

  return (
    <>
    <Header />
    <section className="about-section" id="sobre-nosotros">
      <div className="about-container">

        {/* Header */}
        <div className="about-header">
          <span className="about-badge">Conocé Tresatec</span>
          <h2 className="about-title">Tecnología educativa con propósito</h2>
          <p className="about-subtitle">
            Somos un equipo apasionado por transformar la gestión educativa a través de soluciones digitales claras, cercanas y eficientes.
          </p>
        </div>

        {/* Misión / Filosofía */}
        <div className="about-mission">
          <div className="mission-text">
            <h3>Nuestra misión</h3>
            <p>
              Desde 2020 desarrollamos plataformas que simplifican la administración educativa,
              potencian la comunicación y acompañan a docentes y directivos en cada paso. Además incursionamos en las plataformas educativas para organizaciones, ayudando a simplificar procesos como reclutamiento de personal o capacitación de sus colaboradores.
              Creemos en la tecnología como aliada para liberar tiempo y enfocarnos en lo que importa: enseñar y aprender.
            </p>
            <p>
              En 2023 fuimos seleccionados por el Polo Científico Tecnológico de La Pampa,
              lo que nos permitió consolidar nuestro equipo, infraestructura y seguir innovando.
            </p>
          </div>
          <div className="mission-image">
            <img src={officeImg} alt="Oficina Tresatec" />
            <div className="image-caption">Nuestro equipo en acción</div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="about-stats">
          <div className="stat-item">
            <span className="stat-number">+5</span>
            <span className="stat-label">años de experiencia</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">+3</span>
            <span className="stat-label">instituciones educativas</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">+2000</span>
            <span className="stat-label">usuarios activos</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">desarrollo propio</span>
          </div>
        </div>

<div className="about-milestones-horizontal">
  <h3 className="milestones-title">Nuestra historia</h3>
  <div className="milestones-horizontal-track">
    {milestones.map((m, idx) => (
      <div key={idx} className="milestone-horizontal-item">
        <div className="milestone-dot">
          <span className="milestone-year">{m.year}</span>
        </div>
        <div className="milestone-content">
          <h4>{m.title}</h4>
          <p>{m.description}</p>
        </div>
        {idx < milestones.length - 1 && <div className="milestone-arrow" />}
      </div>
    ))}
  </div>
</div>

{/* Fundadores - una foto grupal + dos descripciones */}
<div className="about-founders">
  <h3>Fundadores</h3>
  <div className="founders-duo">
    {/* Columna izquierda: foto de ambos */}
    <div className="founders-photo">
      <img src={fotoFundadores} alt="Fundadores de Tresatec" />
    </div>
    {/* Columna derecha: dos descripciones */}
    <div className="founders-descriptions">
      <div className="founder-desc">
        <h4>Martin Echeverria</h4>
        <p className="founder-role">CEO & Co-fundador</p>
        <p className="founder-bio">
          Licenciado en sistemas de información, Analista programador, docente.
        </p>
      </div>
      <div className="founder-desc">
        <h4>Matias Boleas</h4>
        <p className="founder-role">CEO & Co-fundador</p>
        <p className="founder-bio">
          Analista Programador y docente.
        </p>
      </div>
    </div>
  </div>
</div>

        {/* CTA final */}
        <div className="about-cta">
          <h3>¿Querés conocer más sobre nosotros?</h3>
          <p>Contactanos y te contamos cómo podemos ayudar a tu organización.</p>
          <div className="cta-buttons">
            <a href="https://wa.me/message/ORWIOZ4UP74NM1" className="btn-primary">Hablar con el equipo</a>
            <a href="/Plataformaeducativa" className="btn-secondary">Conocer Tresaedu</a>
          </div>
        </div>

      </div>
    </section>
    <Footer/>
    </>
  );
}

export default AboutUs;